import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import {Router, Switch, Route} from 'react-router-dom'
import getHistory from "./getHistory"
import * as Sentry from "@sentry/react"
import {Integrations} from "@sentry/tracing"

const history = getHistory()

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing(),],
    tracesSampleRate: 1.0,
    environment: "production"
})

ReactDOM.render(
    <Router history={history}>
        <Switch>
            <Route path="/" component={App}/>
        </Switch>
    </Router>
    , document.getElementById('root')
)
